import { render } from "./BlockRateDonutChart.vue?vue&type=template&id=30b8f369&scoped=true"
import script from "./BlockRateDonutChart.vue?vue&type=script&lang=js"
export * from "./BlockRateDonutChart.vue?vue&type=script&lang=js"

import "./BlockRateDonutChart.vue?vue&type=style&index=0&id=30b8f369&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30b8f369"]])

export default __exports__